
// Imports
import { Injectable } from '@angular/core';


import { XhrService } from '../../service/xhr.service';

// Import RxJs required methods
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { PostBody } from '../../shared/postBody';


@Injectable()
export class DashboardService {

    // Resolve HTTP using the constructor
    constructor(private xhrService: XhrService) {

    }
    



}



// WEBPACK FOOTER //
// ./src/app/admin/dashboard/dashboard.service.ts